'use strict';

const DateUtils = require('utils/DateUtils'),
    DashboardModalUtils = require('components/DashboardModal/DashboardModalUtils'),
    {t} = require('services/i18nextWrapper'),
    Notification = require('components/Notification/Notification'),
    OrderUtils = require('utils/OrderUtils'),
    ContentUtils = require('utils/ContentUtils'),
    _ = require('lodash'),
    Constants = require('constants/AppConstants');

const OrderSingleStore = {

    recalculateSingleOrderTasksWhenDragging(order, positionNew, positionOld){
        const offsetDays = positionNew.y - positionOld.y;
        const isDirectionTop = positionOld.y > positionNew.y;

        // Invert positive or negative depended of the direction.
        let offsetDaysOfFromDate = isDirectionTop ? -Math.abs(offsetDays) : Math.abs(offsetDays);

        // All date tasks must be changes without need to remove any task.
        order.singleTasks = _.map(order.singleTasks, task => {
            task.date = DateUtils.toDateText(DateUtils.addDays(DateUtils.toDate(task.date), offsetDaysOfFromDate));
            // update end dete or each product if needed
            task = OrderUtils.recalculateOffsetProductsEndDate(task, offsetDays);
    
            // Update task of each process
            task = OrderUtils.recalculateProcessDate(task, offsetDays);
            return task;
        });


        return order;
    },


    recalculateSingleOrderTasksWhenResizing(order) {
        // NOTICE: when enter here the `order` is already updated.
        const dateTarget = order.toDate;
        const existingTask = _.find(_.get(order, 'singleTasks'), task => task.date === dateTarget);
    
        if (!existingTask) {
            const newTask = DashboardModalUtils.toEmptyTask(dateTarget);
            newTask.date = dateTarget;
            newTask.type = Constants.SECONDARY_TASK; // singles always are secondary.
            order.singleTasks = ContentUtils.pushSafe(order.singleTasks, newTask);
        }

        order = removeTasksOutOfRange(order);

        return order;
    },

    /**
     * Check all dates of the single order if are properly assigned.
     * @param {Object} order the order to be validated
     * @private
     */
    checkDateOfSingleOrder(order) {
        if (DateUtils.isBefore(order.toDate, order.fromDate)) {
            Notification.show(t('dashboard_notification_brew_date_must_be_before_packaging_date'));
            return false;
        }

        return true;
    },

    /**
     *
     * Given order, change or remove task if are necessary depend is dragging or resizing.
     * @param order
     * @param isDragging
     * @param positionOld
     * @param positionNew
     * @return {*}
     */
    recalculateSingleOrderTasks(order, isDragging, positionOld, positionNew) {

        if (!order) {
            return null;
        }

        if (isDragging) {
            order = this.recalculateSingleOrderTasksWhenDragging(order, positionNew, positionOld);
        } else {
            order = this.recalculateSingleOrderTasksWhenResizing(order);
        }

        return order;
    }
};

function removeTasksOutOfRange(order) {
    order.singleTasks = _.filter(order.singleTasks, function (task) {
        return DateUtils.isBeforeOrEquals(task.date, order.toDate) && DateUtils.isAfterOrEquals(task.date, order.fromDate);
    });
    return order;
}

module.exports = OrderSingleStore;



/** WEBPACK FOOTER **
 ** ./src/stores/OrderSingleStore.js
 **/